import { render, staticRenderFns } from "./ZTagV2.vue?vue&type=template&id=7833c7b3&scoped=true"
import script from "./ZTagV2.vue?vue&type=script&lang=ts"
export * from "./ZTagV2.vue?vue&type=script&lang=ts"
import style0 from "./ZTagV2.vue?vue&type=style&index=0&id=7833c7b3&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833c7b3",
  null
  
)

export default component.exports